module.exports = __webpack_public_path__ + "img/type-red.5ef95792.png";